// First-party cookie helpers (no third-party tracking).
export function setCookie(name, value, days = 365) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/; SameSite=Lax${secure}`;
}

export function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
}

// One-time migration from older localStorage keys -> cookies
export function migrateLocalStorage(map) {
  Object.entries(map).forEach(([lsKey, cookieName]) => {
    try {
      const v = localStorage.getItem(lsKey);
      if (v && !getCookie(cookieName)) setCookie(cookieName, v);
    } catch (e) { console.error('Cookie migration failed:', e); }
  });
}
